import { normalizeCpf } from './cpf';

export const normalizeEmail = value => String(value || '').trim().toLowerCase();

const timestampValue = value => {
  if (!value) return Number.MAX_SAFE_INTEGER;
  const date = typeof value.toDate === 'function' ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime()) ? Number.MAX_SAFE_INTEGER : date.getTime();
};

export const groupClientsByIdentity = (clients = []) => {
  const groups = [];
  const identityGroups = new Map();

  clients.forEach(client => {
    const identities = [
      normalizeCpf(client.cpfNormalized || client.cpf) ? `cpf:${normalizeCpf(client.cpfNormalized || client.cpf)}` : '',
      normalizeEmail(client.email) ? `email:${normalizeEmail(client.email)}` : ''
    ].filter(Boolean);
    const matches = [...new Set(identities.map(identity => identityGroups.get(identity)).filter(Boolean))];
    let group = matches[0];

    if (!group) {
      group = { members: [] };
      groups.push(group);
    }
    matches.slice(1).forEach(other => {
      if (other === group) return;
      group.members.push(...other.members);
      groups.splice(groups.indexOf(other), 1);
      identityGroups.forEach((value, key) => {
        if (value === other) identityGroups.set(key, group);
      });
    });
    group.members.push(client);
    identities.forEach(identity => identityGroups.set(identity, group));
  });

  return groups.map(group => {
    const members = [...group.members].sort((a, b) => (
      timestampValue(a.createdAt) - timestampValue(b.createdAt)
    ));
    const primary = members[0];
    const value = field => members.find(item => item[field])?.[field] || '';
    return {
      ...primary,
      name: value('name'),
      email: value('email'),
      phone: value('phone'),
      cpf: value('cpf'),
      cpfNormalized: value('cpfNormalized') || normalizeCpf(value('cpf')),
      address: value('address'),
      city: value('city'),
      state: value('state'),
      zipCode: value('zipCode'),
      notes: members.map(item => item.notes).filter(Boolean).join(' | '),
      clientIds: members.map(item => item.id),
      clientCpfs: [...new Set(members.map(item => normalizeCpf(item.cpfNormalized || item.cpf)).filter(Boolean))],
      clientEmails: [...new Set(members.map(item => normalizeEmail(item.email)).filter(Boolean))],
      clientRecords: members,
      groupedRecords: members.length
    };
  });
};

export const reservationBelongsToClient = (reservation, client) => {
  const ids = new Set(client.clientIds || [client.id]);
  const cpfs = new Set(client.clientCpfs || [normalizeCpf(client.cpfNormalized || client.cpf)].filter(Boolean));
  const emails = new Set(client.clientEmails || [normalizeEmail(client.email)].filter(Boolean));
  return ids.has(reservation.clientId) ||
    cpfs.has(normalizeCpf(reservation.clientCpf)) ||
    emails.has(normalizeEmail(reservation.clientEmail));
};
